var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"myQuillEditor",staticClass:"picture-text-details",attrs:{"options":_vm.editorOption},model:{value:(_vm.curValue),callback:function ($$v) {_vm.curValue=$$v},expression:"curValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }